// src/client/main.tsx
//
// Phase B T1a: React + Vite entry point (minimal).
// Tailwind / TanStack Query / Router / i18next は T1b / T2 で追加。

// zod 4 の既定エラー文言を zod 3 と同じにする (form の検証文言を変えない)。 ほかの import より先に置く。
import "../shared/zod-compat";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./lib/i18n";
import "./index.css";
import { applyStoredContrast } from "./lib/contrast";

// #706 (gap-g5): 端末に保存した屋外向けの高コントラスト表示を最初の描画の前に効かせる (既定は通常表示のまま)
applyStoredContrast();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
